import { Button } from "@/components/ui/button";

export interface RewardFormActionsSectionProps {
  readonly onCancel: () => void;
  readonly isSubmitting?: boolean;
  readonly submitLabel?: string;
}

export const RewardFormActionsSection = ({
  onCancel,
  isSubmitting = false,
  submitLabel = "Submit",
}: RewardFormActionsSectionProps): React.JSX.Element => {
  return (
    <div className="flex justify-between gap-3">
      <Button
        variant="outline"
        size="md"
        htmlType="button"
        onClick={onCancel}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        size="md"
        htmlType="submit"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Submitting..." : submitLabel}
      </Button>
    </div>
  );
};

